import React from 'react';
import { Link } from 'react-router-dom';
import useScrollPosition from '../../utils/useScrollPosition';

type FooterSpaceProps = {
    viewingGroup?: boolean
}

const FooterSpace = ({ viewingGroup }: FooterSpaceProps) => {

    useScrollPosition();

    let footerStyle = 'grid grid-cols-2 pl-3 shadow-kaho-0 w-full py-2 max-lg:text-sm lg:flex-aho lg:py-4 lg:pl-10 lg:gap-x-10 ';
    let linkStyle = 'cursor-pointer font-extralight transition-slow ';

    if (viewingGroup) {
        footerStyle += 'bg-toto-1';
        linkStyle += 'text-kaho-0 hover:text-kaho-1';
    } else {
        footerStyle += 'bg-kaho-0';
        linkStyle += 'hover:text-toto-2 hover:text-shadow-xs';
    }

    return (
        <div className={footerStyle}>
            <p className={linkStyle}><Link to='/about'>About</Link></p>
            <p className={linkStyle}><Link to='/updates'>Updates</Link></p>
        </div>
    )
}

export default FooterSpace